<template>
  <div>
    <div id="app-loader">
      <div class="spinner"></div>
    </div>
    <NuxtLoadingIndicator color="#f7bf07" />
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
    <Alerts />
    <ContractModal />
  </div>
</template>

<script setup>
onMounted(() => {
  const loader = document.getElementById('app-loader')
  if (loader) loader.remove()
})
</script>

<style>
body {
  overscroll-behavior: none;
}
</style>
